export var Availabilities;
(function (Availabilities) {
    Availabilities["available"] = "available";
    Availabilities["comingSoon"] = "coming soon";
    Availabilities["comingNext"] = "coming next";
})(Availabilities || (Availabilities = {}));
